//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import LocalData from '@/utils/local_data'

import Loading from '@/components/views/loading'
import HouseItem from '@/components/business/house_item'

import BuildDialog from '@/components/business/building_dialog'

import check from '@/common/utils/check'

import { UserLog } from '@/utils/log'

import { DEFAULT_PER } from '@/config'
import Pagination from '@/common/mixins/pagination'
import lpd_tip from '../../result/lpd_tip'
import getStatusClass from '../../result/getStatusClass'

export default {
    mixins: [
        Pagination,
        lpd_tip
    ],
    data () {
        return {
            search_tip: '',
            name: '',
            history: [],
            show_add: false,
            selected: '',
            show_dialog: false,
            title: ''
        }
    },
    computed: {
        showHistory () {
            return !this.loading && !this.items.length
        }
    },
    created () {
        const options = this.$route.query
        this.loading = false
        this.name = options.name || ''
        this.search_tip = options.search_tip || ''
        this.getHistory()
        this.title = options.type === 'lpd' ? '搜索初核结果' : '搜索复核结果'
        if (this.name) {
            Service.init().then(this.getData)
        } else {
            Service.init()
        }
    },
    methods: {
        onBack () {
            this.$router.back()
        },
        getHistory () {
            this.history = LocalData.review_search.get()
        },
        addHisotry (name) {
            LocalData.review_search.add(name)
            this.getHistory()
        },
        removeHisotry () {
            LocalData.review_search.remove()
            this.getHistory()
        },
        selectHistory (name) {
            this.name = name
            this.goSearch(name, true)
        },
        getData () {
            if (!this.name.length || !this.name.trim().length) {
                this.$wx.showToast({
                    title: '请输入要搜索的内容',
                    icon: 'none'
                })
                return
            }
            const { house_id: id, building_id, type } = this.$route.query
            this.loading = true
            const keyword = this.name
            UserLog.regSearch(building_id, keyword)
            const method = type === 'lpd' ? 'getLpdResult' : 'getLrdResult'
            Service[method](id, {
                per: DEFAULT_PER,
                page: this.page,
                keyword
            })
            .then((data) => {
                data.items.forEach((item) => {
                    item.status_class = getStatusClass(item.status)
                })
                return data
            })
            .then(this.handleData)
        },
        getMore () {
            this.page += 1
            this.getData()
        },
        goSearch (name, isSelect = false) {
            if (!isSelect) {
                this.addHisotry(this.name)
            }
            this.page = 1
            this.getData()
            if (check.checkIdCard(name)) {
                Service.getUserInfo().then(({ id_card_number }) => {
                    if (!id_card_number) {
                        this.show_dialog = true
                    }
                })
            }
        },
        search ({ target }) {
            this.goSearch(target.value)
        },
        submit ({ target }) {
            this.goSearch(target.name)
        },
        showAddDlg ({ currentTarget }) {
            this.selected = currentTarget.dataset.index
            this.toggleShowAdd()
        },
        toggleShowAdd () {
            this.show_add = !this.show_add
        },
        confirmAdd () {
            const { house_id: id } = this.$route.query
            const result = this.items[this.selected]
            Service.addUserNum(id, {
                nickname: result.realnames[0],
                ln_number: result.ln_number,
                register_number: result.register_number
            }).then(() => {
                this.toggleShowAdd()
                this.$wx.showToast({
                    title: '添加成功'
                })
            })
        },
        resetName () {
            this.name = ''
        },
        onClose () {
            this.show_dialog = false
        }
    },
    components: {
        Loading,
        HouseItem,
        BuildDialog
    }
}
